import { Phone } from "lucide-react";
import { APP_SUBTITLE, APP_TITLE, LOGO_URL, publicAsset } from "@/shared/config/env";
import { cn } from "@/shared/lib/utils";

const boxes = { sm: "h-8 w-8 rounded-md", md: "h-9 w-9 rounded-lg", lg: "h-11 w-11 rounded-lg" } as const;

/** Logo do cliente (runtime `logoUrl`) ou marca padrão na cor da marca. */
export function BrandMark({ size = "md", className }: { size?: keyof typeof boxes; className?: string }) {
  const logo = publicAsset(LOGO_URL);
  if (logo) return <img src={logo} alt="" className={cn("shrink-0 object-contain", boxes[size], className)} />;
  return (
    <span className={cn("flex shrink-0 items-center justify-center bg-primary text-primary-fg", boxes[size], className)} aria-hidden>
      <Phone className={size === "lg" ? "h-5 w-5" : "h-4 w-4"} strokeWidth={2.25} />
    </span>
  );
}

/** Marca + título + subtítulo do produto (runtime `appTitle`/`appSubtitle`). */
export function BrandLockup({ size = "md", subtitle = APP_SUBTITLE, className }: { size?: keyof typeof boxes; subtitle?: string | null; className?: string }) {
  return (
    <span className={cn("flex min-w-0 items-center gap-2.5", className)}>
      <BrandMark size={size} />
      <span className="min-w-0">
        <span className="block truncate text-body font-semibold text-fg">{APP_TITLE}</span>
        {subtitle ? <span className="block truncate text-caption text-fg-subtle">{subtitle}</span> : null}
      </span>
    </span>
  );
}
